module.exports = "/_next/static/images/d376088bf4850939b71b54e5bb917691-card-background-left-xs.jpg";